import { get } from './apiService';

/**
 * BE response shape for GET /n/{ref}. The targetUrl is already secret-stamped
 * (e.g. /orders/<id>?s=<secret>) — the FE navigates to it and the destination
 * page handles the secret-login via the existing SecretLoginHandler.
 *
 * `title` and `targetUrl` are nullable because email rows persist them on the
 * notification, while view-in-browser flows may not (the BE keeps email HTML
 * in mailgun_events and only stamps a title on push/sms rows).
 */
export interface NotificationSummary {
  id: string;
  ref: string;
  channel: 'email' | 'sms' | 'push';
  category: string;
  event: string;
  title?: string | null;
  targetUrl?: string | null;
  type: string;
}

export async function getNotificationByRef(ref: string): Promise<NotificationSummary> {
  return get<NotificationSummary>(`/n/${encodeURIComponent(ref)}`);
}
